import React from 'react';
import campaignPropType from './propTypes';
import Picture from '../Picture';
import { PICTURE_VARIANTS as SIZES } from '../constants';
import './styles.scss';
import ToggleButton from '../ToggleButton';
import ProgressBar from '../ProgressBar';
import moment from 'moment';

function CampaignRow({
    thumbnail,
    name,
    description,
    pickups,
    target,
    startDate,
    endDate,
    progress,
}) {
    let toggleState = moment(endDate).isSameOrAfter(moment());
    return (
        <div>
            <div className="content-box challengesContentCard">
                <div className="listGroup">
                    <div className="challengesCardAvatar grid">
                        <Picture
                            variant={SIZES.VARIANT_LARGE}
                            source={thumbnail}
                        />
                    </div>
                    <div className="challengesCardContent grid">
                        <div className="card-header">
                            <h2>{name}</h2>
                            <p>{description}</p>
                            <small>{`${startDate} - ${endDate}`}</small>
                        </div>
                    </div>
                    <div className="challengesCardToggle grid">
                        <ToggleButton
                            onToggle={() => {}}
                            toggleState={toggleState}
                            classNames="toggle-switch"
                            inactiveText="Expired"
                        />
                        <div className="avg">
                            <p>
                                <span>{`Pickups ${pickups}`}</span>
                                {`/${target}`}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <ProgressBar progress={progress} isRounded />
        </div>
    );
}

CampaignRow.propTypes = campaignPropType;

CampaignRow.defaultProps = {
    id: null,
    thumbnail: null,
    name: null,
    badge: null,
    description: null,
    pickups: 0,
    target: 0,
    progress: 0,
    startDate: '',
    endDate: '',
};

export default CampaignRow;
